module.exports = __webpack_public_path__ + "img/1725848206850-screenshot-1725848135003.png.7948362a.webp";